import React, { Component } from 'react';
import $ from 'jquery';

class AuthorizationsComponent extends Component {

    togglePopup = (type) => {
        const { showAlert } = this.props
        let msg = null
        let timeOut = 10000
        switch (type) {
            default:
                break;
        }
        // if (msg) {
        //     showAlert({ type: 'warning', message: msg, timeOut: timeOut });
        // }
    };
    render() {
        const { prepareSunatGuide } = this.props
        const currValue = $?.('#selectDocTypeDocumentSearch')?.val() ?? null
        return (
            <div className="d-inline-flex flex-wrap align-items-start">
                <div className="mr-3 mb-2">
                    {currValue === '67' &&
                        <button className="btn btn-success mr-2" onClick={prepareSunatGuide} style={{ width: 252 }}>
                            <i className="far fa-file-alt mr-2" /> Preparar Guía
                        </button>
                    }
                </div>
            </div>
        );
    }
}

export default AuthorizationsComponent;
